import script from "./SubscriptionDetailAppointmentsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubscriptionDetailAppointmentsCard.vue?vue&type=script&setup=true&lang=ts"

import "./SubscriptionDetailAppointmentsCard.vue?vue&type=style&index=0&id=41dba1c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41dba1c4"]])

export default __exports__